import { render, staticRenderFns } from "./TemplateSettings.vue?vue&type=template&id=c9ff5950&scoped=true"
import script from "./TemplateSettings.vue?vue&type=script&lang=js"
export * from "./TemplateSettings.vue?vue&type=script&lang=js"
import style0 from "./TemplateSettings.vue?vue&type=style&index=0&id=c9ff5950&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9ff5950",
  null
  
)

export default component.exports